document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-customer-widget]').forEach(widget => {

    const viewport = widget.querySelector('.customer-widget__viewport');
    const track = widget.querySelector('.customer-widget__track');
    const cards = [...widget.querySelectorAll('.customer-widget__card')];
    const prev = widget.querySelector('.swiper-button-prev');
    const next = widget.querySelector('.swiper-button-next');

    if (!viewport || !track || cards.length === 0) return;

    /* ============================
       CONFIG FROM CSS VARIABLES
    ============================ */
    const styles = getComputedStyle(widget);

    const visibleDesktop =
      parseInt(styles.getPropertyValue('--cw-visible-desktop')) || 3;

    const visibleTablet =
      parseInt(styles.getPropertyValue('--cw-visible-tablet')) || 2;

    const gap =
      parseFloat(styles.getPropertyValue('--cw-gap')) || 0;

    /* ============================
       INTERNAL STATE
    ============================ */
    let cardWidth = 0;
    let cardStep = 0;
    let maxX = 0;
    let currentX = 0;
    let draggable;

    /* ============================
       HELPERS
    ============================ */
    function clamp(x) {
      return Math.max(maxX, Math.min(0, x));
    }

    function visibleCount() {
      if (window.innerWidth <= 640) return 1;
      if (window.innerWidth <= 1024) return visibleTablet;
      return visibleDesktop;
    }

    /* ============================
       MEASURE & LAYOUT
    ============================ */
function measure() {
  const viewportWidth =
    viewport.getBoundingClientRect().width;

  let visible;

  if (window.innerWidth <= 640) {
    visible = parseInt(
      getComputedStyle(widget)
        .getPropertyValue('--cw-visible-mobile')
    ) || 1;
  } else if (window.innerWidth <= 1024) {
    visible = parseInt(
      getComputedStyle(widget)
        .getPropertyValue('--cw-visible-tablet')
    ) || 2;
  } else {
    visible = parseInt(
      getComputedStyle(widget)
        .getPropertyValue('--cw-visible-desktop')
    ) || 3;
  }

  // 🔑 Core layout math (gap-aware)
  cardWidth =
    (viewportWidth - gap * (visible - 1)) / visible;

  cards.forEach(card => {
    card.style.width = `${cardWidth}px`;
  });

  cardStep = cardWidth + gap;

  const trackWidth =
    cardWidth * cards.length +
    gap * (cards.length - 1);

  maxX = Math.min(0, viewportWidth - trackWidth);
}



    /* ============================
       SNAP LOGIC
    ============================ */
    function snap(x) {
      const index = Math.round(x / cardStep);
      return clamp(index * cardStep);
    }

    function goTo(x, animate = true) {
      currentX = snap(x);

      gsap.to(track, {
        x: currentX,
        duration: animate ? 0.35 : 0,
        ease: 'power3.out'
      });
    }

    /* ============================
       INIT
    ============================ */
    measure();

    draggable = Draggable.create(track, {
      type: 'x',
      bounds: () => ({ minX: maxX, maxX: 0 }),
      inertia: true,

      dragResistance: 0.05,
      edgeResistance: 0.75,
      throwResistance: 2000,
      overshootTolerance: 0.3,

      allowContextMenu: true,

      onPress() {
        gsap.killTweensOf(track);
      },

      onDrag() {
        currentX = this.x;
      },

      onRelease() {
        goTo(this.x);
      },

      onThrowComplete() {
        goTo(this.x);
      }
    })[0];

    /* ============================
       ARROWS
    ============================ */
    prev?.addEventListener('click', () => {
      goTo(currentX + cardStep);
    });

    next?.addEventListener('click', () => {
      goTo(currentX - cardStep);
    });

    /* ============================
       RESIZE
    ============================ */
    window.addEventListener('resize', () => {
      measure();
      draggable.applyBounds({ minX: maxX, maxX: 0 });
      goTo(currentX, false);
    });

  });
});
